import { c as _c } from "react/compiler-runtime";
interface WaveSettingEditorActionsProps {
  readonly disabled: boolean;
  readonly secondaryAction?: {
    readonly disabled: boolean;
    readonly label: string;
    readonly onClick: () => void;
    readonly variant?: "danger" | "neutral" | undefined;
  } | null;
  readonly onCancel: () => void;
  readonly submitDisabled?: boolean | undefined;
}
export default function WaveSettingEditorActions(t0) {
  const $ = _c(13);
  const {
    disabled,
    onCancel,
    secondaryAction: t1,
    submitDisabled: t2
  } = t0;
  const secondaryAction = t1 === undefined ? null : t1;
  const submitDisabled = t2 === undefined ? false : t2;
  const secondaryActionClasses = secondaryAction?.variant === "neutral" ? "tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-iron-300 tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-text-iron-100" : "tw-rounded-md tw-border tw-border-solid tw-border-red/40 tw-bg-transparent tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-red tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-red desktop-hover:hover:tw-text-red";
  let t3;
  if ($[0] !== disabled || $[1] !== onCancel) {
    t3 = <button type="button" disabled={disabled} onClick={onCancel} className="tw-rounded-md tw-border tw-border-solid tw-border-iron-700 tw-bg-transparent tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-iron-300 tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-iron-500 desktop-hover:hover:tw-text-iron-100">Cancel</button>;
    $[0] = disabled;
    $[1] = onCancel;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== disabled || $[4] !== secondaryAction || $[5] !== secondaryActionClasses) {
    t4 = secondaryAction && <button type="button" disabled={disabled || secondaryAction.disabled} onClick={secondaryAction.onClick} className={secondaryActionClasses}>{secondaryAction.label}</button>;
    $[3] = disabled;
    $[4] = secondaryAction;
    $[5] = secondaryActionClasses;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = disabled || submitDisabled;
  let t6;
  if ($[7] !== t5) {
    t6 = <button type="submit" disabled={t5} className="tw-rounded-md tw-border tw-border-solid tw-border-primary-500 tw-bg-primary-500 tw-px-3 tw-py-2 tw-text-xs tw-font-semibold tw-text-white tw-transition disabled:tw-cursor-not-allowed disabled:tw-opacity-50 desktop-hover:hover:tw-border-primary-600 desktop-hover:hover:tw-bg-primary-600">Save</button>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t4 || $[11] !== t6) {
    t7 = <div className="tw-flex tw-items-center tw-justify-end tw-gap-2">{t3}{t4}{t6}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}